import { atom } from 'jotai';
import { atomWithReset, atomWithStorage } from 'jotai/utils';
import { AvatarFrameType } from '@/__generated__/graphql';

export const totalNotification = atom<number>(0);

export const timeUserStartVisitAtom = atomWithStorage<string | undefined>(
  'timeReChooseProfile',
  undefined,
);

export const frameAvatarTabAtom = atomWithReset(AvatarFrameType.Frame);
